document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('.section-welcome-popup');
  const popupWrap = popup.querySelector('.welcome-block-wrapper');
  const closeButton = document.querySelector('.welcome-close-popup');
  const maxShowTimes = parseInt(popupWrap.getAttribute('data-show-popup'), 10);
  let closeCount = sessionStorage.getItem('welcomePopupCloseCount') || 0;

  function showPopup() {
    popup.classList.remove('welcome-popup-hidden');
  }

  function hidePopup() {
    popup.classList.add('welcome-popup-hidden');
    closeCount++;
    sessionStorage.setItem('welcomePopupCloseCount', closeCount);
  }

  if (closeCount < maxShowTimes) {
    setTimeout(showPopup, 5000);
  }

  closeButton.addEventListener('click', hidePopup);
  closeButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      hidePopup();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      hidePopup();
    }
  });
});